module.exports = __webpack_public_path__ + "img/curriculum-empty.570b8603.png";